var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-datepicker',_vm._g(_vm._b({attrs:{"id":_vm.id,"aria-label":_vm.$gettext('Select date to filter payout table')}},'b-form-datepicker',_vm.attrsWithTranslations,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }